/* eslint-disable react/no-children-prop,react/no-danger-with-children */
import { useMemo } from 'react';
import type { MdComponentIndexProps } from '../type';
import type { SupportIconProps } from './SupportIconPropsNode';

export function UrlIcon({
  icon,
  iconSize,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  iconColor,
  className,
  style,
  ...props
}: SupportIconProps & MdComponentIndexProps & { className?: string; style?: React.CSSProperties }) {
  const IconSize = useMemo(() => {
    if (typeof iconSize === 'number') return iconSize;
    if (typeof iconSize === 'string') {
      try {
        const res = Number(iconSize);
        return Number.isNaN(res) ? iconSize : res;
      } catch (e) {
        return iconSize;
      }
    }
    return undefined;
  }, [iconSize]);
  // console.log(IconSize);
  if (!icon) return null;
  return (
    <img
      className={className}
      src={icon}
      {...props}
      /* eslint-disable-next-line react/no-danger-with-children,react/no-children-prop */
      children={null}
      /* eslint-disable-next-line react/no-danger-with-children */
      dangerouslySetInnerHTML={undefined}
      style={{
        width: IconSize ?? '1em',
        ...style,
      }}
    />
  );
}
